import React, { Component } from "react";
import "styled-components/macro";

import blueOutLogo from "./images/blue-out-logo.png";
import dottedBar from "./images/dotted-bar.png";
import dottedC from "./images/dotted-C.png";

export default class BonusFeaturesZeroBranding extends Component {
  initialState = {
    animationStep: 1,
  };
  state = this.initialState;
  timers = [];
  animationMs = 500;
  render() {
    return (
      <div
        onMouseEnter={this.startAnimation}
        onMouseLeave={this.resetAnimation}
        css={`
          position: relative;
          display: inline-flex;
          margin: 16px 0 0;
          width: 33%;
          height: 500px;
          color: white;
          cursor: grab;
          border-radius: 15.0px;
          overflow: hidden;
          background-color: hsl(240 11% 95% / 1);
          box-shadow: 2.5px 2.2px 0px 0.5px hsl(240deg 8% 90%);
          border: 1px solid hsl(0deg 0% 54% / 40%);
          filter: brightness(1.07);
          transition: filter 140ms ease-out;
          &:hover {
            box-shadow: none;
            filter: brightness(1);
            #dottedBarContainer,
            #dottedC {
              filter: brightness(1);
            }
          }
        `}
      >
        <div
          css={`
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
          `}
        >
          <div
            css={`
              padding: 39px 0 0 39px;
              font-weight: 600;
              font-size: 14px;
              color: hsl(240 50% 55% / 1);
            `}
          >
            NON-BRANDED EXPERIENCE
          </div>
          <div
            css={`
              margin-top: 190px;
              font-size: 24px;
              line-height: 122%;
              padding: 39px;
            `}
          >
            <div
              css={`
                font-size: 21px;
                color: hsl(240 10% 35% / 1);
              `}
            >
              <strong>Low-to-Zero Branding</strong>
            </div>
            <div
              css={`
                line-height: 133.5%;
                font-size: 18px;
                color: hsl(240 10% 60% / 1);
              `}
            >
              After you have signed in, you won't see our logo again. It's
              important to us that your RSS reading experience is as uncluttered
              as possible.
            </div>
          </div>
        </div>
        <div
          css={`
            position: absolute;
            top: 0;
          `}
        >
          <div
            css={`
              position: absolute;
              top: 165px;
              left: 52px;
            `}
          >
            <img
              src={blueOutLogo}
              alt="blueOutLogo"
              css={`
                width: 66.5px;
                transform: ${this.calcTransformBlueLogo()};
                opacity: ${this.calcOpacityBlueLogo()};
                transition: all ${this.animationMs}ms ease-out;
              `}
            />
          </div>
          <div
            css={`
              position: absolute;
              top: 63px;
              left: 39px;
            `}
          >
            <div
              id="dottedBarContainer"
              css={`
                z-index: 1;
                position: relative;
                width: 70px;
                height: 118px;
                margin: 0 0 5px;
                background: hsl(240 11% 95% / 1);
                transform: translateY(
                  ${this.state.animationStep >= 7 ? "83px" : "0px"}
                );
                transition: transform ${this.animationMs * 1}ms
                  cubic-bezier(0.4, 0, 0.2, 1);
                /* filter: brightness(0.53); */
                animation: ${this.state.animationStep >= 8
                  ? "blink 900ms linear infinite alternate-reverse"
                  : "none"};
                @keyframes blink {
                  0% {
                    filter: opacity(0);
                  }
                  23% {
                    filter: opacity(1);
                  }
                  100% {
                    filter: opacity(1);
                  }
                }
              `}
            >
              <img
                src={dottedBar}
                alt="dottedBar"
                css={`
                  position: absolute;
                  bottom: -1px;
                  width: 70px;
                  height: 17px;
                `}
              />
            </div>
            <div>
              <img
                id="dottedC"
                src={dottedC}
                alt="dottedC"
                css={`
                  width: 70px;
                  /* filter: brightness(0.53); */
                  opacity: ${this.state.animationStep >= 8 ? 0 : 1};
                `}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  startAnimation = () => {
    this.timers[1] = setTimeout(() => {
      this.setState({ animationStep: 1 });
      this.timers[2] = setTimeout(() => {
        this.setState({ animationStep: 2 });
        this.timers[3] = setTimeout(() => {
          this.setState({ animationStep: 3 });
          this.timers[4] = setTimeout(() => {
            this.setState({ animationStep: 4 });
            this.timers[5] = setTimeout(() => {
              this.setState({ animationStep: 5 });
              this.timers[6] = setTimeout(() => {
                this.setState({ animationStep: 6 });
                this.timers[7] = setTimeout(() => {
                  this.setState({ animationStep: 7 });
                  this.timers[8] = setTimeout(() => {
                    this.setState({ animationStep: 8 });
                  }, this.animationMs);
                }, this.animationMs);
              }, this.animationMs);
            }, this.animationMs);
          }, this.animationMs);
        }, this.animationMs);
      }, 1);
    }, this.animationMs * 0.25);
  };

  resetAnimation = () => {
    this.timers.forEach((timer) => {
      clearTimeout(timer);
    });
    this.setState(this.initialState);
  };

  // calcFilterBlueLogo = () => {
  //   const { animationStep } = this.state;
  //   const filterStandard = "saturate(0%) brightness(100%)";

  //   if (animationStep === 0) return filterStandard;
  //   else if (animationStep === 1)
  //     return "saturate(100%)";
  //   else if (animationStep === 2)
  //     return "saturate(50%)";
  //   else if (animationStep === 3)
  //     return "saturate(50%)";
  //   else if (animationStep >= 4)
  //     return "saturate(100%)";
  // };

  calcTransformBlueLogo = () => {
    const { animationStep } = this.state;

    if (animationStep >= 3) return "translateX(-10px)";
    else return "translateX(0px)";
  };

  calcOpacityBlueLogo = () => {
    const { animationStep } = this.state;

    if (animationStep >= 4) return 0;
    else return 1;
  };
}
